export enum AddInstantBillV2SubmitEnum {
  SAVE_AND_CLOSE = 'saveAndClose',
  CONTINUE_TO_PAY = 'continueToPay',
}
export enum AddInstantBill2RecurringEndBy {
  DATE = 'end-date',
  OCCURRENCES = 'num-of-occurrences',
}

export type AddInstantBillV2SubmitType = AddInstantBillV2SubmitEnum;
